import { Hash, Users } from 'lucide-react'
import type { Suggestion } from '@/lib/autocomplete'
import { cx } from '@/lib/cx'
import { Avatar } from '../Avatar'
import styles from './MentionPopup.module.css'

const colorOf = (id: string) => `hsl(${Number(id.slice(-4)) % 360} 55% 50%)`

/** Список подсказок над полем ввода; управляется с клавиатуры из поля. */
export function MentionPopup({ items, active, title, onPick, onHover }: { items: Suggestion[]; active: number; title: string; onPick: (s: Suggestion) => void; onHover: (i: number) => void }) {
  if (!items.length) return null
  return (
    <div className={styles.popup} role="listbox" aria-label={title}>
      <div className={styles.title}>{title}</div>
      {items.map((s, i) => (
        <button
          key={s.key}
          type="button"
          role="option"
          aria-selected={i === active}
          className={cx(styles.item, i === active && styles.itemActive)}
          onMouseEnter={() => onHover(i)}
          onMouseDown={(e) => {
            e.preventDefault()
            onPick(s)
          }}
        >
          {s.kind === 'emoji' ? (
            s.emojiUrl ? <img src={s.emojiUrl} alt="" className={styles.emojiImg} /> : <span className={styles.emojiChar}>{s.emoji}</span>
          ) : s.kind === 'user' ? (
            <Avatar initial={s.label.slice(0, 1).toUpperCase()} color={colorOf(s.key)} size={22} src={s.avatar} />
          ) : s.kind === 'role' ? (
            <span className={styles.roleIcon} style={{ color: s.color ?? 'var(--text-muted)' }}><Users size={16} /></span>
          ) : (
            <Hash size={16} className={styles.channelIcon} />
          )}
          <span className={styles.label} style={s.kind === 'role' && s.color ? { color: s.color } : undefined}>{s.label}</span>
          {s.bot ? <span className={styles.botTag}>БОТ</span> : null}
          {s.hint ? <span className={styles.hint}>{s.hint}</span> : null}
        </button>
      ))}
    </div>
  )
}
